import { Alert, Modal } from 'antd';
import React from 'react';

import DefaultButton from 'components/atoms/DefaultButton';
import LogOutButton from 'components/buttons/LogOutButton';
import { ENTERPRISE_NOT_FOUND_MESSAGE } from 'constants/enterprise';
import { goToEnterpriseList } from 'utils/URL/switch-enterprises';

interface Props {
  errorMessage: string;
}

const SwitchEnterprisesButton = () => {
  return (
    <DefaultButton onClick={goToEnterpriseList}>
      Switch enterprises
    </DefaultButton>
  );
};

function ErrorModal({ errorMessage }: Props): JSX.Element {
  if (errorMessage === 'Network Error') {
    const reloadButton = (
      <DefaultButton type="primary" onClick={() => window.location.reload()}>
        Reload
      </DefaultButton>
    );
    return (
      <Modal
        title="You seem to be offline"
        open
        closable={false}
        footer={reloadButton}
      >
        <Alert
          message="Sorry, we are unable to load the page due to poor reception. Please check your connectivity and try again"
          type="error"
        />
      </Modal>
    );
  }

  const showSwitchEnterprisesButton: boolean = errorMessage === ENTERPRISE_NOT_FOUND_MESSAGE;
  const footerButtons = [
    showSwitchEnterprisesButton && <SwitchEnterprisesButton key="switch-enterprises" />,
    <LogOutButton key="logout" />
  ].filter(Boolean);

  return (
    <Modal
      title="Sorry, something went wrong."
      open
      closable={false}
      footer={footerButtons}
    >
      <Alert message={errorMessage} type="error" />
    </Modal>
  );
}

export default ErrorModal;
